import { StyleRules } from '@material-ui/core/styles';
import { StepLabelClasskey } from '@material-ui/core/StepLabel';

import { MOBILE_FONT_SIZE } from '../styles/constants/MOBILE_FONT_SIZE';

import { core as theme } from '../styles/core';

export const MuiStepLabel: Partial<StyleRules<StepLabelClasskey>> = {
  label: {
    ...theme.typography.h6,
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h6}rem`,
    },

    '&$active, &$completed': {
      color: theme.palette.primary.main,
    },
    '&$alternativeLabel': {
      marginTop: theme.spacing(0.5),
    },
  },
};
